var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarFacilityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.89154C12.5 5.3332 12.225 4.81654 11.7583 4.5082L8.425 2.2832C7.86667 1.9082 7.13333 1.9082 6.575 2.2832L3.24167 4.5082C2.78333 4.81654 2.5 5.3332 2.5 5.89154V10.6249C2.5 10.8582 2.68333 11.0415 2.91667 11.0415H12.0833C12.3167 11.0415 12.5 10.8582 12.5 10.6249V5.89154ZM7.5 8.9582C6.7 8.9582 6.04167 8.29987 6.04167 7.49987C6.04167 6.69987 6.7 6.04154 7.5 6.04154C8.3 6.04154 8.95833 6.69987 8.95833 7.49987C8.95833 8.29987 8.3 8.9582 7.5 8.9582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 17.7086H17.2753V15.2086C18.067 14.9503 18.642 14.2086 18.642 13.3336V11.6669C18.642 10.5753 17.7503 9.68359 16.6587 9.68359C15.567 9.68359 14.6753 10.5753 14.6753 11.6669V13.3336C14.6753 14.2003 15.242 14.9336 16.017 15.2003V17.7086H12.5003V12.7086C12.5003 12.4753 12.317 12.2919 12.0837 12.2919H2.91699C2.68366 12.2919 2.50033 12.4753 2.50033 12.7086V17.7086H1.66699C1.32533 17.7086 1.04199 17.9919 1.04199 18.3336C1.04199 18.6753 1.32533 18.9586 1.66699 18.9586H16.6087C16.6253 18.9586 16.6337 18.9669 16.6503 18.9669C16.667 18.9669 16.6753 18.9586 16.692 18.9586H18.3337C18.6753 18.9586 18.9587 18.6753 18.9587 18.3336C18.9587 17.9919 18.6753 17.7086 18.3337 17.7086ZM6.87533 15.2086C6.87533 14.8669 7.15866 14.5836 7.50033 14.5836C7.84199 14.5836 8.12533 14.8669 8.12533 15.2086V17.7086H6.87533V15.2086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFacilityActive);
export default __webpack_public_path__ + "static/media/sidebar-facility-active.f98b687ac1ba57d07a957da6474efc32.svg";
export { ForwardRef as ReactComponent };